// Veil (dither) preferences — the ONE store for how the user's netti wears its
// ASCII veil. The default is the calm DOTS look (VEIL_DOTS). The /netti
// appearance panel writes here and dispatches `innernet:veil-tune` so the live
// organism updates immediately; the dashboard reads it on load to seed the veil.
// Persisted per-browser in localStorage (like the ground feel).

import { VEIL_DOTS } from "./shaders";

export const VEIL_PREFS_KEY = "innernet:veil";

/** the user's saved veil params merged over the DOTS default (all keys present). */
export function loadVeilPrefs(): Record<string, number> {
  if (typeof window === "undefined") return { ...VEIL_DOTS };
  try {
    const raw = window.localStorage.getItem(VEIL_PREFS_KEY);
    if (!raw) return { ...VEIL_DOTS };
    const parsed = JSON.parse(raw) as Record<string, number>;
    return { ...VEIL_DOTS, ...parsed };
  } catch {
    return { ...VEIL_DOTS };
  }
}

export function saveVeilPrefs(params: Record<string, number>): void {
  try {
    window.localStorage.setItem(VEIL_PREFS_KEY, JSON.stringify(params));
  } catch {
    /* private mode — non-persisted, still live for the session */
  }
}
